export const FONT_SIZE_HTML = 16; // Browser default (better not to change)
export const FONT_SIZE_BODY = 14; // Browser default (better not to change)

export const DRAWER_WIDTH = 320;

export const DESKTOP_NAVIGATION_WIDTH = 280;
export const DESKTOP_NAVIGATION_WIDTH_COLLAPSED = 80;

export const TOOLBAR_HEIGHT = 64;
